
const divisionGrades = {
    "school": [
        { id: 1, value: "4", label: "כתה א" },
        { id: 2, value: "5", label: "כתה ב" },
        { id: 3, value: "6", label: "כתה ג" },
        { id: 4, value: "7", label: "כתה ד" },
        { id: 5, value: "8", label: "כתה ה" },
        { id: 6, value: "9", label: "כתה ו" },
    ],
    "brigade": [
        { id: 7, value: "10", label: "כתה ז" },
        { id: 8, value: "11", label: "כתה ח" },
        { id: 9, value: "12", label: "כתה ט" }
    ],
    "highSchool": [
        { id: 10, value: "13", label: "כתה י" },
        { id: 11, value: "14", label: "כתה יא" },
        { id: 12, value: "15", label: "כתה יב" },
    ]
}

export default divisionGrades